import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  currentUser = new BehaviorSubject<any>(null);

  constructor(private httpClient: HttpClient) { 

  }
  setSharedUser(data: any) {
    this.currentUser.next(data);
  }

  getSharedUser() {
    return this.currentUser.asObservable();
  }

  getUserData() {

    return this.httpClient.get(environment.apiUrl + '/account/get-user-info');
  }

  updateUser(data: any) {
    return this.httpClient.patch(environment.apiUrl + '/account/update-user-info', data);
  }

 
  updateAddress(data: any) {
    const params = new HttpParams({ fromObject: data }); 
    return this.httpClient.patch(environment.apiUrl + `/account/update-address`, null, { params });
  }
  getClosestServiceProviders(data: any) {
    const params = new HttpParams({ fromObject: data }); 
    return this.httpClient.get(environment.apiUrl + `/service-provider/closest/get`, { params });
  }
  
  updateUserImage(data: any) {
    return this.httpClient.post(environment.apiUrl + `/account/update-user-image`, data)
  }
  deleteUserImage() {
    return this.httpClient.delete(environment.apiUrl + `/account/delete-user-image`)
  }
  deleteAccount() {
    return this.httpClient.delete(environment.apiUrl + `/account/delete-account`)
  }
  updateUserBanner(data: any) {
    return this.httpClient.post(environment.apiUrl + `/service-provider/profile/update-banner`, data)
  }
  deleteProviderBanner() {
    return this.httpClient.delete(environment.apiUrl + `/service-provider/profile/delete-banner`)
  }

  changePassword(data: any) {
    return this.httpClient.patch(environment.apiUrl + '/account/change-password', data);
  }



}
